import { render } from "./BottomListWallpaperView.vue?vue&type=template&id=5ea3e8c7&scoped=true"
import script from "./BottomListWallpaperView.vue?vue&type=script&lang=js"
export * from "./BottomListWallpaperView.vue?vue&type=script&lang=js"

import "./BottomListWallpaperView.vue?vue&type=style&index=0&id=5ea3e8c7&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea3e8c7"]])

export default __exports__